import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSearchContext } from "../chats/searchContext";
import "../../styles/home/home.css";
import "bootstrap-icons/font/bootstrap-icons.css";

import searchIcon from "../../images/chats/search_icon.png";
import noImage from "../../images/collections/no_image.png";

const Home = () => {
    const [getSearch, setSearch] = useState("");
    const [getCardSpaceNum, setCardSpaceNum] = useState(1);
    const [getSortedVoteList, setSortedVoteList] = useState([]);
    const [getOriginalSortedVoteList, setOriginalSortedVoteList] = useState([]);

    const {
        getIsActionLoading, getIsThrillerLoading, getIsComedyLoading, getIsHorrorLoading, getIsFamilyLoading, getIsMysteryLoading,
        getIsAnimationLoading, getIsDramaLoading, getIsAdventureLoading, getIsRomanceLoading, getIsScienceFictionLoading, getIsNewsLoading,
        getIsKidsLoading, getIsRealityLoading, getIsSoapLoading, getIsTalkLoading, getIsWarLoading, getIsWesternLoading,
        getIsHistoryLoading, getIsDocumentaryLoading, getIsFantasyLoading, getIsCrimeLoading, getIsMusicLoading, getActionError, 
        getThrillerError, getComedyError, getHorrorError, getFamilyError, getMysteryError, getAnimationError, getDramaError, getAdventureError,
        getRomanceError, getScienceFictionError, getNewsError, getKidsError, getRealityError, getSoapError, getTalkError, getWarError, 
        getWesternError, getHistoryError, getDocumentaryError, getFantasyError, getCrimeError, getMusicError, getActionList, setActionList,
        getThrillerList, setThrillerList, getComedyList, setComedyList, getHorrorList, setHorrorList, getFamilyList, setFamilyList,
        getMysteryList, setMysteryList, getAnimationList, setAnimationList, getDramaList, setDramaList, getAdventureList, setAdventureList,
        getRomanceList, setRomanceList, getScienceFictionList, setScienceFictionList, getNewsList, setNewsList, getKidsList, setKidsList,
        getRealityList, setRealityList, getSoapList, setSoapList, getTalkList, setTalkList, getWarList, setWarList, getWesternList, setWesternList,
        getHistoryList, setHistoryList, getDocumentaryList, setDocumentaryList, getFantasyList, setFantasyList, getCrimeList, setCrimeList,
        getMusicList, setMusicList, getOriginalActionList, getOriginalThrillerList, getOriginalComedyList, getOriginalHorrorList,
        getOriginalFamilyList, getOriginalMysteryList, getOriginalAnimationList, getOriginalDramaList, getOriginalAdventureList,
        getOriginalRomanceList, getOriginalScienceFictionList, getOriginalNewsList, getOriginalKidsList, getOriginalRealityList,
        getOriginalSoapList, getOriginalTalkList, getOriginalWarList, getOriginalWesternList, getOriginalHistoryList, getOriginalDocumentaryList,
        getOriginalFantasyList, getOriginalCrimeList, getOriginalMusicList, getBackIndex, setBackIndex, getBackImages, getVotedList,
        getOriginalVotedList, getVotedError, getIsVotedLoading,
    } = useSearchContext();

    const onChangeSearch = (search) => {
        setSearch(search.target.value);
    };

    const getCardSpace = () => {
        const parent = document.getElementById('action_container_home_screen');
        const parentWidth = parent.offsetWidth;
        const childWidth = window.innerWidth <= 600 ? 110 : 150 + 30;
        const numChildren = Math.floor(parentWidth / childWidth);
        document.querySelectorAll(".action_container_home_screen").forEach(parent => {
            parent.style.gridTemplateColumns = `repeat(${numChildren}, 1fr)`;
        });
        setCardSpaceNum(numChildren);
    }

    const sortVoteList = useCallback(() => {
        const seenIds = new Set();
        const sortList = [];
        getVotedList.forEach((movie) => {
            if (!seenIds.has(movie.id)) {
                seenIds.add(movie.id);
                sortList.push(movie);
            }
        });

        setSortedVoteList(sortList);
        setOriginalSortedVoteList(sortList);
    }, [getVotedList]);

    useEffect(() => {
        sortVoteList();
    }, [getVotedList, sortVoteList]);

    useEffect(() => {
        getCardSpace();
        const handleResize = () => {
            getCardSpace(); 
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [getSortedVoteList]);

    useEffect(() => {
        const filteredListA = getOriginalActionList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListT = getOriginalThrillerList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListM = getOriginalMysteryList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListF = getOriginalFamilyList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListH = getOriginalHorrorList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListC = getOriginalComedyList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListAn = getOriginalAnimationList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListD = getOriginalDramaList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListAd = getOriginalAdventureList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListR = getOriginalRomanceList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListS = getOriginalScienceFictionList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListN = getOriginalNewsList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListK = getOriginalKidsList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListRe = getOriginalRealityList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListSo = getOriginalSoapList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListTa = getOriginalTalkList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListW = getOriginalWarList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListWe = getOriginalWesternList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListHi = getOriginalHistoryList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListDo = getOriginalDocumentaryList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListFa = getOriginalFantasyList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListCr = getOriginalCrimeList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListMu = getOriginalMusicList.filter((item) => {
            return item.title && item.title.toLowerCase().includes(getSearch.toLowerCase());
        });

        const filteredListV = getOriginalSortedVoteList.filter((item) => {
            return item.name && item.name.toLowerCase().includes(getSearch.toLowerCase());
        });

        setActionList(filteredListA);
        setThrillerList(filteredListT);
        setMysteryList(filteredListM);
        setFamilyList(filteredListF);
        setHorrorList(filteredListH);
        setComedyList(filteredListC);
        setAnimationList(filteredListAn);
        setDramaList(filteredListD);
        setAdventureList(filteredListAd);
        setRomanceList(filteredListR);
        setScienceFictionList(filteredListS);
        setNewsList(filteredListN);
        setKidsList(filteredListK);
        setRealityList(filteredListRe);
        setSoapList(filteredListSo);
        setTalkList(filteredListTa);
        setWarList(filteredListW);
        setWesternList(filteredListWe);
        setHistoryList(filteredListHi);
        setDocumentaryList(filteredListDo);
        setFantasyList(filteredListFa);
        setCrimeList(filteredListCr);
        setMusicList(filteredListMu);
        setSortedVoteList(filteredListV);
    }, [
            getSearch, getOriginalActionList, getOriginalThrillerList, 
            getOriginalMysteryList, getOriginalFamilyList, getOriginalHorrorList, 
            getOriginalComedyList, getOriginalAnimationList, getOriginalDramaList, 
            getOriginalAdventureList, getOriginalRomanceList, getOriginalScienceFictionList, 
            getOriginalNewsList, getOriginalKidsList, getOriginalRealityList, 
            getOriginalSoapList, getOriginalTalkList, getOriginalWarList, 
            getOriginalWesternList, getOriginalHistoryList, getOriginalDocumentaryList, 
            getOriginalFantasyList, getOriginalCrimeList, getOriginalMusicList, getOriginalSortedVoteList,
            setActionList, setThrillerList, 
            setMysteryList, setFamilyList, setHorrorList, 
            setComedyList, setAnimationList, setDramaList, 
            setAdventureList, setRomanceList, setScienceFictionList, 
            setNewsList, setKidsList, setRealityList, 
            setSoapList, setTalkList, setWarList, 
            setWesternList, setHistoryList, setDocumentaryList, 
            setFantasyList, setCrimeList, setMusicList, setSortedVoteList,
        ]); 

    useEffect (() => {
        const intaDf = setInterval(() => {
            document.getElementById("aDf_background").style.backgroundImage = `url(${getBackImages[getBackIndex]})`;
            if (getBackIndex >= getBackImages.length - 1) {
                setBackIndex(0);
            } else {
                setBackIndex(getBackIndex + 1);
            }
        }, 60000);

        return () => clearInterval(intaDf);
    }, [setBackIndex, getBackIndex, getBackImages]);

    return(
        <div className="home_screen">
            <div className="aDf" >
                <div id="aDf_background" className="aDf_background" ></div>
                <div className="aDf_overlay"></div>
                <div className="aDf_content">
                <p className="aDf_content_header">Welcome</p>
                    <p className="aDf_content_sub">Discover your favorite movies and TV shows.</p>
                    <div className="home_search_user_input_container">
                        <img alt="search" src={searchIcon} className="home_search_user_input_icon"/>
                        <input className="home_search_user_input_field" id="search_movie" placeholder="Search for any movie or tv series..." type="text" value={getSearch} onChange={onChangeSearch} />
                    </div>
                </div>
            </div>
            
            <div className="home_screen_main_con">
                {
                    getSortedVoteList.length > 0
                    ? <div className="home_screen_containers">
                        <p className="action_container_header_home_screen_2"><span role="img" aria-label="star symbol">⭐</span> Top Voted Movies and TV Series</p>
                        <div id="action_container_home_screen" className="action_container_home_screen">
                            <div id="card_home_screen" className="card_home_screen"></div>
                            {
                                getVotedError === "" 
                                ? (
                                    getSortedVoteList.length > 0
                                    ? getSortedVoteList.map((movie, index) => (
                                        index < getCardSpaceNum
                                        ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/${movie.genre}/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item_2">
                                            <img
                                                loading='lazy'
                                                src={movie.image === "" || movie.image === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.image}`}
                                                alt={movie.name}
                                                className="movie_poster_2"
                                            />
                                            <p className="movie_item_p_2">{movie.name}</p>
                                        </div></Link>
                                        : null
                                    ))
                                    : getIsVotedLoading
                                    ? <p className="action_container_home_screen_p">Loading...</p>
                                    : <p className="action_container_home_screen_p">There are no voted movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                                )
                                : <p>{getVotedError}</p>
                            }
                        </div>
                        <Link to={getOriginalVotedList.length <= 0 ? null : "/main_back/home/top-votes"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">view ↠</p></Link>
                    </div>
                    : null
                }

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Action</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getActionError === "" 
                            ? (
                                getActionList.length > 0
                                ? getActionList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/action/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsActionLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no action movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getActionError}</p>
                        }
                    </div>
                    <Link to={getOriginalActionList.length <= 0 ? null : "/main_back/home/action-movies-and-series/28"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Thriller</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getThrillerError === "" 
                            ? (
                                getThrillerList.length > 0
                                ? getThrillerList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/thriller/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsThrillerLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no thriller movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getThrillerError}</p>
                        }
                    </div>
                    <Link to={getOriginalThrillerList.length <= 0 ? null : "/main_back/home/thriller-movies-and-series/53"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Mystery</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getMysteryError === "" 
                            ? (
                                getMysteryList.length > 0
                                ? getMysteryList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/mystery/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsMysteryLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no mystery movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getMysteryError}</p>
                        }
                    </div>
                    <Link to={getOriginalMysteryList.length <= 0 ? null : "/main_back/home/mystery-movies-and-series/9648"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Crime</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getCrimeError === "" 
                            ? (
                                getCrimeList.length > 0
                                ? getCrimeList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/crime/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsCrimeLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no crime movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getCrimeError}</p>
                        }
                    </div>
                    <Link to={getOriginalCrimeList.length <= 0 ? null : "/main_back/home/crime-movies-and-series/80"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Kids</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getKidsError === "" 
                            ? (
                                getKidsList.length > 0
                                ? getKidsList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/kids/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsKidsLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no kids movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getKidsError}</p>
                        }
                    </div>
                    <Link to={getOriginalKidsList.length <= 0 ? null : "/main_back/home/kids-movies-and-series/10762"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Family</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getFamilyError === "" 
                            ? (
                                getFamilyList.length > 0
                                ? getFamilyList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/family/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsFamilyLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no family movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getFamilyError}</p>
                        }
                    </div>
                    <Link to={getOriginalFamilyList.length <= 0 ? null : "/main_back/home/family-movies-and-series/10751"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Horror</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getHorrorError === "" 
                            ? (
                                getHorrorList.length > 0
                                ? getHorrorList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/horror/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsHorrorLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no horror movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getHorrorError}</p>
                        }
                    </div>
                    <Link to={getOriginalHorrorList.length <= 0 ? null : "/main_back/home/horror-movies-and-series/27"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Comedy</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getComedyError === "" 
                            ? (
                                getComedyList.length > 0
                                ? getComedyList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/comedy/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsComedyLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no comedy movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getComedyError}</p>
                        }
                    </div>
                    <Link 
                    to={getOriginalComedyList.length <= 0 ? null : "/main_back/home/comedy-movies-and-series/35"} 
                    className="action_container_sub_home_screen_see_more"
                    >
                        <p className="action_container_sub_home_screen">see more ↠</p>
                    </Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Music</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getMusicError === "" 
                            ? (
                                getMusicList.length > 0
                                ? getMusicList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/music/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsMusicLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no music movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getMusicError}</p>
                        }
                    </div>
                    <Link to={getOriginalMusicList.length <= 0 ? null : "/main_back/home/music-movies-and-series/10402"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Animation</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getAnimationError === "" 
                            ? (
                                getAnimationList.length > 0
                                ? getAnimationList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/animation/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsAnimationLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no animated movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getAnimationError}</p>
                        }
                    </div>
                    <Link 
                    to={getOriginalAnimationList.length <= 0 ? null : "/main_back/home/animation-movies-and-series/16"} 
                    className="action_container_sub_home_screen_see_more"
                    >
                        <p className="action_container_sub_home_screen">see more ↠</p>
                    </Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Drama</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getDramaError === "" 
                            ? (
                                getDramaList.length > 0
                                ? getDramaList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/drama/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsDramaLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no drama movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getDramaError}</p>
                        }
                    </div>
                    <Link 
                    to={getOriginalDramaList.length <= 0 ? null : "/main_back/home/drama-movies-and-series/18"} 
                    className="action_container_sub_home_screen_see_more"
                    >
                        <p className="action_container_sub_home_screen">see more ↠</p>
                    </Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Soap</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getSoapError === "" 
                            ? (
                                getSoapList.length > 0
                                ? getSoapList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/soap/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsSoapLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no soap movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getSoapError}</p>
                        }
                    </div>
                    <Link to={getOriginalSoapList.length <= 0 ? null : "/main_back/home/soap-movies-and-series/10766"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Reality</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getRealityError === "" 
                            ? (
                                getRealityList.length > 0
                                ? getRealityList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/reality/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsRealityLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no reality movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getRealityError}</p>
                        }
                    </div>
                    <Link to={getOriginalRealityList.length <= 0 ? null : "/main_back/home/reality-movies-and-series/10764"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Adventure</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getAdventureError === "" 
                            ? (
                                getAdventureList.length > 0
                                ? getAdventureList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/adventure/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsAdventureLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no adventure movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getAdventureError}</p>
                        }
                    </div>
                    <Link 
                    to={getOriginalAdventureList.length <= 0 ? null : "/main_back/home/adventure-movies-and-series/10763"} 
                    className="action_container_sub_home_screen_see_more"
                    >
                        <p className="action_container_sub_home_screen">see more ↠</p>
                    </Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Romance</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getRomanceError === "" 
                            ? (
                                getRomanceList.length > 0
                                ? getRomanceList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/romance/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsRomanceLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no romance movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getRomanceError}</p>
                        }
                    </div>
                    <Link 
                    to={getOriginalRomanceList.length <= 0 ? null : "/main_back/home/romance-movies-and-series/10749"} 
                    className="action_container_sub_home_screen_see_more"
                    >
                        <p className="action_container_sub_home_screen">see more ↠</p>
                    </Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Science Fiction</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getScienceFictionError === "" 
                            ? (
                                getScienceFictionList.length > 0
                                ? getScienceFictionList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/science-fiction/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsScienceFictionLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no science fiction movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getScienceFictionError}</p>
                        }
                    </div>
                    <Link 
                    to={getOriginalScienceFictionList.length <= 0 ? null : "/main_back/home/science-fiction-movies-and-series/878"} 
                    className="action_container_sub_home_screen_see_more"
                    >
                        <p className="action_container_sub_home_screen">see more ↠</p>
                    </Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Fantasy</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getFantasyError === "" 
                            ? (
                                getFantasyList.length > 0
                                ? getFantasyList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/fantasy/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsFantasyLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no fantasy movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getFantasyError}</p>
                        }
                    </div>
                    <Link to={getOriginalFantasyList.length <= 0 ? null : "/main_back/home/fantasy-movies-and-series/14"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Talk</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getTalkError === "" 
                            ? (
                                getTalkList.length > 0
                                ? getTalkList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/talk/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsTalkLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no talk movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getTalkError}</p>
                        }
                    </div>
                    <Link to={getOriginalTalkList.length <= 0 ? null : "/main_back/home/talk-movies-and-series/10767"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">History</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getHistoryError === "" 
                            ? (
                                getHistoryList.length > 0
                                ? getHistoryList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/history/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsHistoryLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no history movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getHistoryError}</p>
                        }
                    </div>
                    <Link to={getOriginalHistoryList.length <= 0 ? null : "/main_back/home/history-movies-and-series/36"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Documentary</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getDocumentaryError === "" 
                            ? (
                                getDocumentaryList.length > 0
                                ? getDocumentaryList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/documentary/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsDocumentaryLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no documentary movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getDocumentaryError}</p>
                        }
                    </div>
                    <Link to={getOriginalDocumentaryList.length <= 0 ? null : "/main_back/home/documentary-movies-and-series/99"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">War</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getWarError === "" 
                            ? (
                                getWarList.length > 0
                                ? getWarList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/war/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsWarLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no war movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getWarError}</p>
                        }
                    </div>
                    <Link to={getOriginalWarList.length <= 0 ? null : "/main_back/home/war-movies-and-series/10752"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">News</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getNewsError === "" 
                            ? (
                                getNewsList.length > 0
                                ? getNewsList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/news/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsNewsLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no news movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getNewsError}</p>
                        }
                    </div>
                    <Link 
                    to={getOriginalNewsList.length <= 0 ? null : "/main_back/home/news-movies-and-series/10763"} 
                    className="action_container_sub_home_screen_see_more"
                    >
                        <p className="action_container_sub_home_screen">see more ↠</p>
                    </Link>
                </div>

                <div className="home_screen_containers">
                    <p className="action_container_header_home_screen">Western</p>
                    <div id="action_container_home_screen" className="action_container_home_screen">
                        <div id="card_home_screen" className="card_home_screen"></div>
                        {
                            getWesternError === "" 
                            ? (
                                getWesternList.length > 0
                                ? getWesternList.map((movie, index) => (
                                    index < getCardSpaceNum
                                    ? <Link className="action_container_sub_home_screen_a" to={`/main_back/home/western/${movie.type}/${movie.id}`}><div key={index} id="movie_item" className="movie_item">
                                        <img
                                            loading='lazy'
                                            src={movie.poster_path === "" || movie.poster_path === null ? noImage : `https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                                            alt={movie.title}
                                            className="movie_poster"
                                        />
                                        <p className="movie_item_p">{movie.title}</p>
                                    </div></Link>
                                    : null
                                ))
                                : getIsWesternLoading
                                ? <p className="action_container_home_screen_p">Loading...</p>
                                : <p className="action_container_home_screen_p">There are no western movies or tv series{getSearch !== "" ? ` based on your search '${getSearch}' ` : " "}sorry...</p>
                            )
                            : <p>{getWesternError}</p>
                        }
                    </div>
                    <Link to={getOriginalWesternList.length <= 0 ? null : "/main_back/home/western-movies-and-series/37"} className="action_container_sub_home_screen_see_more"><p className="action_container_sub_home_screen">see more ↠</p></Link>
                </div>
            </div>
        </div>
    );
};

export default Home;